// extracted by mini-css-extract-plugin
export default {"container":"bra_1IdCB","image":"bra_ima_24VmS"};